import { ListLink } from "@components"

import { 
  CheckBadgeIcon, 
  Cog6ToothIcon, 
  DocumentMagnifyingGlassIcon,
  FolderMinusIcon, 
  Square2StackIcon, 
  Square3Stack3DIcon, 
  UserIcon, 
  VideoCameraIcon 
} from "@heroicons/react/24/outline"

import { VIEWS } from "../data"
import PropTypes from "prop-types"

const EventItems = ({ handleMenuSelect }) => (
  <div>
    <ListLink title={VIEWS.IMPERSONATE.title} description={VIEWS.IMPERSONATE.subTitle} icon={UserIcon} iconColor="text-indigo-800 dark:text-content2-foreground" handleClick={() => handleMenuSelect(VIEWS.IMPERSONATE)} />
    <ListLink title={VIEWS.ACCESS.title} description={VIEWS.ACCESS.subTitle} icon={CheckBadgeIcon} iconColor="text-indigo-800 dark:text-content2-foreground" handleClick={() => handleMenuSelect(VIEWS.ACCESS)} />
    <ListLink title={VIEWS.BASIC_INFO.title} description={VIEWS.BASIC_INFO.subTitle} icon={Square2StackIcon} iconColor="text-indigo-800 dark:text-content2-foreground" handleClick={() => handleMenuSelect(VIEWS.BASIC_INFO)} />
    <ListLink title={VIEWS.MEETING_TYPES.title} description={VIEWS.MEETING_TYPES.subTitle} icon={VideoCameraIcon} iconColor="text-indigo-800 dark:text-content2-foreground" handleClick={() => handleMenuSelect(VIEWS.MEETING_TYPES)} />
    <ListLink title={VIEWS.SETTINGS.title} description={VIEWS.SETTINGS.subTitle} icon={Cog6ToothIcon} iconColor="text-indigo-800 dark:text-content2-foreground" handleClick={() => handleMenuSelect(VIEWS.SETTINGS)} />
    <ListLink title={VIEWS.SESSIONS.title} description={VIEWS.SESSIONS.subTitle} icon={Square3Stack3DIcon} iconColor="text-indigo-800 dark:text-content2-foreground" handleClick={() => handleMenuSelect(VIEWS.SESSIONS)} />    
    <ListLink title={VIEWS.META.title} description={VIEWS.META.subTitle} icon={DocumentMagnifyingGlassIcon} iconColor="text-indigo-800 dark:text-content2-foreground" handleClick={() => handleMenuSelect(VIEWS.META)} />
    <ListLink title={VIEWS.DELETE.title} description={VIEWS.DELETE.subTitle} icon={FolderMinusIcon} iconColor="text-red-600" handleClick={() => handleMenuSelect(VIEWS.DELETE)} showDivider={false} />
  </div>
)

EventItems.propTypes = {
  handleMenuSelect: PropTypes.func.isRequired,
}

export default EventItems